/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { IInventoryModel } from '../../models/account/IInventoryModel';

export enum InventoryActionTypes {
  GetInventory = '[INVENTORY] Get Inventory',
  GetInventorySuccess = '[INVENTORY] Get Inventory Success',
  GetInventoryError = '[INVENTORY] Get Inventory Error'
}

export class GetInventory implements Action {
  readonly type = InventoryActionTypes.GetInventory;
}

export class GetInventorySuccess implements Action {
  readonly type = InventoryActionTypes.GetInventorySuccess;
  constructor(public payload: IInventoryModel[]) {}
}

export class GetInventoryError implements Action {
  readonly type = InventoryActionTypes.GetInventoryError;
}

export type InventoryActions = GetInventory | GetInventorySuccess | GetInventoryError;
